// import Page from './NotUsed/SyncfusionPage';
import Page from './Antd/AntdPage';


type PropType = {
    children?: any;
};
export default function FactoryPage({ children }: PropType) {
    return (<Page>{children}</Page>);
}